module.exports = __webpack_public_path__ + "static/Oswald-Medium-843477dfdda31297fe46c098002c3652.woff2";